import useIsMobile from '@/hooks/useIsMobile';
import React from 'react';
import { ChevronRight } from 'lucide-react';
import { Typography } from '@pw-tech/omni-ui';
const CourseSidebar = ({
  batchWiseCourseData,
  selectedCourseId,
  onBatchSelect,
  onHover,
  selectedBatch
}: {
  batchWiseCourseData: any;
  selectedCourseId: any;
  onBatchSelect: (batchId: string) => void;
  onHover: (batchId: string) => void;
  selectedBatch: any;
}) => {
  const isMobileScreen = useIsMobile();
  return <div className="overflow-hidden bg-white rounded-lg shadow-sm" data-sentry-component="CourseSidebar" data-sentry-source-file="CourseSidebar.tsx">
      {batchWiseCourseData?.map((data: any, index: number) => <div key={`${data?.batch?._id ?? ''}${data?.batch?.name ?? ''}`} className="">
          <button type="button" className={`w-full px-4 py-4 sm:px-6 sm:py-5 text-left hover:bg-gray-50 transition-colors duration-200 ${selectedBatch?.batch?._id === data?.batch?._id ? 'bg-gray-50 ' : ''}`} onClick={() => onBatchSelect(data?.batch?._id)} onMouseEnter={() => !isMobileScreen && onBatchSelect(data?.batch?._id)}>
            <div className="flex items-center justify-between">
              <div className="flex-1">
                <Typography variant="regular">{data?.batch?.name}</Typography>
                <p className="text-xs text-gray-600 sm:text-sm">
                  {data?.batch?.subTitle ?? `subtitle${index}`}
                </p>
              </div>

              <ChevronRight className="w-5 h-5 text-gray-400" />
            </div>
          </button>
        </div>)}
    </div>;
};
export default CourseSidebar;